import { render } from "./purchase-receipt.vue?vue&type=template&id=86256c8c&scoped=true"
import script from "./purchase-receipt.vue?vue&type=script&lang=js"
export * from "./purchase-receipt.vue?vue&type=script&lang=js"

import "./purchase-receipt.vue?vue&type=style&index=0&id=86256c8c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86256c8c"]])

export default __exports__